<template>
	<div class="popup_wrap">
    <span @click="openDetailModal">
		<slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="체험관 이용 확약서">
		<div v-if="loaded" ref="printText" class="rg_promise_box1">
		<!--상단-->
		<div class="rg_promise_top">
			<p class="promise_logo">한국잡월드 체험관 이용 확약서</p>
			<p class="promise_txt">한국잡월드 체험관 이용을 온라인으로 예약하고 이용료 사전 결제에 갈음하기 위하여 아래와 같이 확약합니다.</p>
		</div>
		<!--//상단-->
		<!--입력 테이블-->
		<div class="rg_promise_input tb_wrap">
			<table width="100%">
				<tbody>
					<tr>
						<td class="p_tt" style="">○ 단&nbsp;체&nbsp;명&nbsp;&nbsp;:&nbsp;&nbsp;{{appointList.schoolNm}}</td>
						<td class="p_tt01">(전화번호&nbsp;&nbsp;:&nbsp;&nbsp;{{appointList.userPhoneNum}})</td>
					</tr>
						<tr>
						<td class="p_tt" style="" colspan="2">○ 단&nbsp;체&nbsp;장&nbsp;&nbsp;:&nbsp;&nbsp; {{appointList.principalNm}}</td>
					</tr>
					<tr>
						<td class="p_tt" style="" colspan="2">○ 단체주소&nbsp;&nbsp;:&nbsp;&nbsp;우)&nbsp;{{appointList.postCd}}&nbsp;&nbsp;{{appointList.basicAddress}}&nbsp;{{appointList.etcAddress}}</td>
					</tr>
					<tr>
						<td class="p_tt" style="">○ 신&nbsp;청&nbsp;자&nbsp;&nbsp;:&nbsp;&nbsp;{{appointList.writerNm}}</td>
						<td class="p_tt01">(휴대폰&nbsp;&nbsp;:&nbsp;&nbsp;{{appointList.userMobileNum}})</td>
					</tr>
				</tbody>
			</table>
		</div>
		<!--//입력 테이블-->
		<!--예약 내용 테이블-->
		<div class="rg_promise_table tb_wrap" >
			<p class="rg_p03 title"  style=""><b>체험예약&nbsp;내역</b></p>
			<p class="rg_p03 content"  style="">○&nbsp;체험일&nbsp;&nbsp;:&nbsp;&nbsp;{{resultList[0].expVisitRvdtF}}</p>
				<table>
					<thead>
						<tr>
							<th rowspan="2" width="10%">예약번호</th>
							<th rowspan="2" width="15%">체험관</th>
							<th rowspan="2" width="12%">회차</th>
							<th width="18%">체험인원</th>
							<th width="15%">이용금액(A)</th>
							<th width="15%">할인금액(B)</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(result, i) in resultList" :key="i">
							<td v-if="result.bundleRvNo && i===0"  style="font-size: 14px" class="p_num" :rowspan="resultList.length">{{result.bundleRvNo}}</td>
							<td style="font-size: 14px;word-break: keep-all;" class="p_room" :rowspan="result.cnt">{{result.pdNm}}</td>
							<td style="font-size: 14px">{{result.scheSeqNo}}<br/>({{result.scheTm}})</td>
							<td style="font-size: 14px">체험자&nbsp;&nbsp;{{result.experPcnt}}인 <br/>인솔자&nbsp;&nbsp;{{result.leaderPcnt}}인</td>
							<td style="font-size: 14px">{{_priceFormat(result.rvAmt+result.dcAmt)}}원</td>
							<td style="font-size: 14px">{{_priceFormat(result.dcAmt)}}원</td>
						</tr>
						<tr>
							<td colspan="2" style="font-size: 17px">이용금액(A)<br/>{{_priceFormat(totOriginPrice)}}원</td>
							<td colspan="2" style="font-size: 17px">할인금액(B)<br/>{{_priceFormat(totDcPrice)}}원</td>
							<td colspan="2" style="font-size: 17px">결제할 금액(A-B)<br/>{{_priceFormat(totSalePrice)}}원</td>
						</tr>
					</tbody>
				</table>
				<p style="margin:10px 0 10px 0;font-size: 14px;">※ 금액은 당일 이용인원에 따라 달라질수 있습니다.</p>
				<p class="rg_p05" style="margin-top:10px;">{{appointList.yearDt}}년&nbsp;&nbsp;{{appointList.monDt}}월&nbsp;&nbsp;{{appointList.dayDt}}일</p>
				<p class="rg_p06">{{appointList.schoolNm}}&nbsp;단체장&nbsp;&nbsp;&nbsp;(인)</p>
				<p class="rg_p07">한국잡월드&nbsp;이사장&nbsp;귀하</p>				
			</div>
			<!--//예약 내용 테이블-->
			<!--하단 내용-->
			<div class="pagediv rg_promise_txt" style="">
				<div class="rg_p02">
					<p class="rg_p03">&lt;유의사항&gt;<BR/>[공통]</p>
					<p class="rg_p04">
						<div class="p_indent">-</div>
						<div>30분전에 도착하여 입장료를 결제하고 이용자별로 티켓을 받아 정해진 시간부터 체험할 수 있도록 준비하여 주시기 바랍니다.</div>
					</p>
					<p class="rg_p04">
						<div class="p_indent">-</div>
						<div>이용인원의 변동이 예상되면 별도로 연락하여 주시기 바랍니다.(전화 1644-1333)</div>
					</p>
					<p class="rg_p04">
						<div class="p_indent">-</div>
						<div>확약서 팩스 전송처(팩스 031-696-8421)</div>
					</p>
					<p class="rg_p03">[청소년체험관/숙련기술체험관]</p>
					<p class="rg_p04">
						<div class="p_indent">-</div>
						<div>청소년체험관, 숙련기술체험관은 이용확약서를 제출하면 이용일 15일 전에 예약이 승인되며, 승인 후 체험실을 선착순으로 선택할 수 있습니다.</div>
					</p>
					<p class="rg_p04">
						<div class="p_indent">-</div>
						<div>체험실을 미리 선택하지 않은 경우, 당일 추천 체험실로 배정됩니다.</div>
					</p>
					<p class="rg_p04">
						<div class="p_indent">-</div>
						<div>원활한 체험 진행을 위하여 체험 시작 30분 경과 후에는 입장이 불가하며, 최대 20분 경과 후에는 참관으로 진행됨을 알려드립니다.</div>
					</p>
				</div>
			</div>
			<div class="rg_price">
				<p style="text-align:center;font-size:20px;margin:15px 0 10px 0;"><b>&lt;이용요금기준안내&gt;</b></p>
				<!-- img style="width:99%;" src="/file/txt_pay08_20220321.jpg" alt="이용요금기준안내" /-->
				<div class="tb_wrap mb10">
					<table class="tb_basic">
						<colgroup>
							<col width="15%" />
							<col width="15%" />
							<col />
							<col />
						</colgroup>
						<thead>
							<tr class="tbg">
								<th colspan="2" scope="col">대상</th>
								<th scope="col">회차당 이용금액</th>
								<th scope="col">비고</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colspan="2">청소년체험관/미래직업관</td>
								<td>9,000원</td>
								<td>
									당일 추가체험 시
									<br />
									회차당 6,000원씩 가산
								</td>
							</tr>
							<tr>
								<td rowspan="3">어린이체험관</td>
								<td>체험자</td>
								<td>18,000원</td>
								<td>
									당일 추가체험 시
									<br />
									15,000원 가산
								</td>
							</tr>
							<tr>
								<td>보호자</td>
								<td>9,000원</td>
								<td>
									당일 추가체험 시
									<br />
									5,000원 가산
								</td>
							</tr>
							<tr>
								<td>단체인솔자</td>
								<td>4,000원</td>
								<td>1일 이용요금</td>
							</tr>
							<tr>
								<td colspan="2">진로설계관</td>
								<td>3,000원</td>
								<td>
									청소년체험관 이용자 무료
									<br />
									어린이체험관 이용자 무료
								</td>
							</tr>
							<tr>
								<td colspan="2">숙련기술체험관</td>
								<td>5,000원</td>
								<td></td>
							</tr>
							<tr>
								<td colspan="2">메카이브 K.Ground</td>
								<td>
								10,000원
								</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
				<p style="text-align:center;font-size:20px;margin:15px 0 10px 0;"><b>&lt;주차요금&gt;</b></p>

				<div class="tb_wrap mb10">
					<table class="tb_basic">
						<colgroup>
						<col width="10%" />
							<col width="28%" />
							<col width="20%" />
							<col />
						</colgroup>
						<tbody>
							<tr>
								<td rowspan="5">일반요금</td>
								<td rowspan="2">
								기본60분
								<br />
								(무료60분 포함 120분에 해당)
								</td>
								<td>소형차</td>
								<td class="price_color">5,000원</td>
							</tr>
							<tr>
								<td>대형차</td>
								<td class="price_color">10,000원</td>
							</tr>
							<tr>
								<td rowspan="2">추가60분당</td>
								<td>소형차</td>
								<td class="price_color">4,000원</td>
							</tr>
							<tr>
								<td>대형차</td>
								<td class="price_color">6,000원</td>
							</tr>
							<tr>
								<td colspan="3">
								※ 일 최대요금: 소형차
								<span class="price_color">20,000원</span>
								, 대형차
								<span class="price_color">40,000원</span>
								</td>
							</tr>
							<tr>
								<td colspan="2">체험관 등 이용 고객</td>
								<td colspan="2">
								소형차
								<span class="price_color">5,000원</span>
								/ 대형차
								<span class="price_color">10,000원</span>
								<br />
								1시간 무료, 1일 정액권( 소형차
								<span class="price_color">5,000원</span>
								/ 대형차
								<span class="price_color">10,000원</span>
								)
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<!--//하단 내용-->
		</div>
		<!--//확약서 작성-->
		<template slot="footer">
			<div class="btn_wrap" style="justify-content: center">
				<a class="btn btn_bg color1 btn_popup" @click="onEditClick">수정</a>
				<a class="btn btn_bg line btn_popup" @click="onPrintClick">인쇄</a> 
				<a class="all-full btn btn_bg gray" @click="closeModal">닫기</a>
			</div>
		</template>
		<!-- /footer -->
    </modal>
	</div>
</template>
<script>
import api from '@/api/api_config';
import { mapActions } from 'vuex';
import { isLoggedIn, gfn_popup } from '@/utils/reserve';
import Modal from '@/components/common/Modal.vue';
import TabItem from '@/components/common/TabItem.vue';
const printStyle = `
		/*확약서 작성*/
		.rg_promise_wrap{width:100%;display:block;margin-bottom:10px;margin-top:10px;}
		.rg_promise_wrap h4{font-family:'NotoKrB';font-size:18px;color:#333;letter-spacing:-1.5px;padding-bottom:10px;}
		.rg_promise_box1{margin-bottom:10px;border:1px solid #ccc;padding:20px 20px;}
		.rg_promise_box1 div.rg_promise_top{width:100%;margin:0 auto;text-align:center;}
		.rg_promise_box1 div.rg_promise_top p.promise_logo{font-size:28px;font-family:'NotoKrB';letter-spacing:-1px;color:#333;margin-bottom:15px;}
		.rg_promise_box1 div.rg_promise_top p.promise_txt{font-size:20px;color:#999;margin-bottom:5px;text-align:left;}
		.rg_promise_box1 div.rg_promise_input{width:100%;}
		.rg_promise_box1 div.rg_promise_input table{width:100%; text-align: initial;}
		.rg_promise_box1 div.rg_promise_input table tr td.p_tt{width:13%;font-size:17px;letter-spacing:-1px;color:#666;line-height:180%;height:35px;}
		.rg_promise_box1 div.rg_promise_input table tr td.p_tt01{text-align:right;width:10%;font-size:17px;letter-spacing:-1px;color:#666;line-height:180%;}
		.rg_promise_box1 div.rg_promise_input table tr td.p_tt02{width:20%;text-align:right;}
		.rg_promise_box1 div.rg_promise_table {width:100%;padding-top:10px;}
		.rg_promise_box1 div.rg_promise_table h4 {width:100%;margin-top:20px;}
		.rg_promise_box1 div.rg_promise_table table thead th {text-align: center;background-color:#e5e5e5;border-top:2px solid #0177c1;border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;color: #31343f;vertical-align: middle;font-size:15px;font-weight: 700;}
		.rg_promise_box1 div.rg_promise_table table thead th:last-child{padding:10px 0px;border-right:none;}
		.rg_promise_box1 div.rg_promise_table table tbody td {padding:10px 0px;font-size: 15px;letter-spacing:-1px;height: 16px;text-align: center; border-bottom: 1px solid #e1e2e2; border-right: 1px solid #e1e2e2; color:#666;}
		.rg_promise_box1 div.rg_promise_table table tbody td:last-child{border-right:none;}
		.rg_promise_box1 div.rg_promise_table table thead td.tdcols{padding:10px 0px;color:#31343f;text-align:center;background-color:#efefef;border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;}
		.rg_promise_box1 div.rg_promise_table table thead td.tdcols:last-child{border-right:none;}
		.rg_promise_box1 div.rg_promise_table table tbody td.p_room{color:#333;font-weight:300;padding: 6px 0 7px;}
		.rg_promise_box1 div.rg_promise_table table tbody td.p_num{color:#0177c1;font-weight:300;padding: 6px 0 7px;}
		.rg_promise_box1 div.rg_promise_txt{width:100%;margin-top:30px;}
		.rg_promise_box1 div.rg_promise_txt p.rg_p01{font-size:17px;letter-spacing:-1px;margin-bottom:30px;}
		.rg_promise_box1 div.rg_promise_txt div.rg_p02{width:100%;border:1px solid #ccc;padding-bottom:10px;}
		.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p03{font-size:15px;letter-spacing:-1px;color:#333;font-weight:600;margin:10px;}
		.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p04{font-size:15px;letter-spacing:-1px;color:#666;margin:0px 10px;}
		.p_indent {float:left;margin-left:10px;}
		.p_indent + div {margin:0 10px 0 20px;} 
		.rg_promise_box1 div.rg_promise_txt div.rg_p02 span.rg_under{text-decoration:underline;}
		.rg_promise_box1 div.rg_promise_table p.rg_p05{text-align:right;font-size:17px;letter-spacing:-1px;margin-top:40px;}
		.rg_promise_box1 div.rg_promise_table p.rg_p06{text-align:right;font-size:17px;letter-spacing:-1px;margin-top:10px;}
		.rg_promise_box1 div.rg_promise_table p.rg_p07{text-align:center;font-size:22px;letter-spacing:4px;color:#333;font-weight:bold;margin:20px 0 20px 0;}
		.rg_p03.title {color: rgb(102, 102, 102); font-size: 18px;margin-bottom:10px;}
		.rg_p03.content {color: rgb(102, 102, 102); font-size: 17px;margin-bottom:10px;}

		.tb_basic { width: 100%; border-top: 2px solid #444444; border-collapse: collapse; text-align:center; }
		.tb_basic th { border-bottom: 1px solid #666; padding: 10px; font-weight:500; color:#333;}
		.tb_basic thead th { padding: 15px 10px;}
		.tb_basic thead th:first-child { border-left:0;}
		.tb_basic thead th:last-child { border-right:0;}
		.tb_basic tbody th:first-child, .tb_basic tbody td:first-child{ border-left:0;}
		.tb_basic tbody th:last-child { border-right:0;}
		.tb_basic tbody th, .tb_basic td { border: 1px solid #ccc; padding: 10px; }
		.tb_basic tr td:last-child { border-right:0; }
		.tb_basic .tbg { background:#f8f8f8; color:#333 }

		@media print {
			.pagediv {page-break-before: always !important;}
			.rg_promise_box1 {margin : 0px;}
			.rg_promise_box1 div.rg_promise_txt div.rg_p02 {width:100%;}
			.rg_promise_box1 div.rg_promise_top p.promise_logo{font-size:24px;}	
			.rg_promise_box1 div.rg_promise_top p.promise_txt{font-size:16px;}
			.rg_promise_box1 div.rg_promise_input{margin-top:-10px;}
			.rg_promise_box1 div.rg_promise_input table tr td.p_tt{font-size:14px;line-height:120%;height:25px;}
			.rg_promise_box1 div.rg_promise_input table tr td.p_tt01{font-size:14px;line-height:120%;height:25px;}	
			.rg_promise_box1 div.rg_promise_top{width:100%;margin:0;text-align:center;}	
			.rg_promise_box1 div.rg_promise_txt{width:100%;margin-top:30px;}
			.rg_promise_box1 div.rg_promise_table {padding-top:0px;}
			.rg_promise_box1 div.rg_promise_table table tbody td {padding:5px 0px;font-size: 15px;letter-spacing:-1px;height: 16px;text-align: center; border-bottom: 1px solid #e1e2e2; border-right: 1px solid #e1e2e2; color:#666;}
			.rg_promise_box1 div.rg_promise_txt p.rg_p01{font-size:15px;letter-spacing:-1px;margin-bottom:30px;}
			.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p03 > b{font-size:14px;}
			.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p03{font-size:14px;letter-spacing:-1px;color:#333;font-weight:600;margin:10px;}
			.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p04{font-size:14px;letter-spacing:-1px;color:#666;margin:0px 10px;}
			.rg_p03.title {font-size: 14px;line-height:100%;height:10px;margin-bottom:0px;}
			.rg_p03.content {font-size: 14px;line-height:100%;height:20px;margin-bottom:0px;}
			.p_indent {font-size:13px;}
			.p_indent + div {font-size:13px;margin:-5px 10px -10px 20px;}

			.rg_price { font-size:14px; }
			.rg_price .colorbox { background: #f8f8f8; padding: 20px; text-align: left; position: relative; width: auto; word-break: keep-all;}
			.rg_price .tb_basic { width: 100%; border-top: 2px solid #444444; border-collapse: collapse; text-align: center; font-size: 14px; }
			.rg_price .tb_basic .tbg { background: #f8f8f8; color: #333; }
			.rg_price .tb_basic tbody th:first-child, .tb_basic tbody td:first-child, .tb_basic tfoot td:first-child { border-left: 0; }
			.rg_price .tb_basic thead th:first-child { border-left: 0; }
			.rg_price .tb_basic tbody th, .tb_basic td { border: 1px solid #ccc; padding: 5px; }
			.rg_price .tb_basic thead th { padding: 15px 10px; }
			.rg_price .tb_basic th { border-bottom: 1px solid #666; padding: 10px;  font-weight: 500; color: #333; }			
		}
`
function print(text){
	var win = window.open();
	self.focus();
	win.document.open();
	win.document.write('<html><head><title>한국잡월드 체험관 이용 확약서</title>');
	win.document.write('<style>'+printStyle+'</style>');
	win.document.write('</head><body>');
	win.document.write(text);
	win.document.write('</body></html>');
	win.document.close();
	win.print();

	// 광고차단 플러그인 방지
	setTimeout(() => {
		win.close();
	}, 500);
}

export default {
  components: { Modal, TabItem },
  props: {
    bundleRvNo: {
      type: String,
      default: '',
    },
    openRpp: {
      type: Function
    }
  },
  data() {
    return {
      modal: {
        open: false,
      },
      loaded: false,
      appointList: {},
      resultList: [],
    };
  },
  computed: {
    totOriginPrice() {
      return this.resultList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.resultList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.resultList.reduce((a, e) => a + e.rvAmt, 0);
    },
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.loadGrpDcdfpr();
      }
    },
    schulNm(to) {
      this.schulMstr = to;
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo']),
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    openDetailModal() {
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    onEditClick(){
      this.closeModal();
      this.openRpp();
    },
    onPrintClick(){
      print(this.$refs.printText.outerHTML);
    },
    async loadGrpDcdfpr() {
      const param = {
        bundleRvNo: this.bundleRvNo,
        type: 'P',
      };
      let form = new FormData();
      for (let key in param) {
        form.append(key, param[key]);
      }
      try {
        const result = await api.post('/api/reservation/' + this.bundleRvNo + '/grpDcdfpr', form);
        if (result.data.success) {
          const response = result.data.response;
          this.resultList = response.resultList;
          
          // 기존자료 입력
          if (response.appointList) {
            const appointList = response.appointList?.[0] || {};
            this.appointList = appointList

            this.schulNm = appointList.schoolNm;
            this.phoneNum = appointList.userPhoneNum;
            this.schulMaster = appointList.principalNm;
            this.detAdd = appointList.etcAddress;
            this.genAdd = appointList.basicAddress;
            this.zipcode = appointList.postCd;
            this.userNm = appointList.writerNm;
            this.userMobile = appointList.userMobileNum;
            this.schulMstr = appointList.schoolNm;

            const modDt = appointList.modDt;
            this.d_year = modDt.substr(0, 4);
            this.d_month = modDt.substr(4, 2);
            this.d_day = modDt.substr(6, 2);
          } else if (response.userInfo?.[0]) {
            const userInfo = response.userInfo[0];
            this.schulNm = userInfo.orgName || '';
            this.phoneNum = userInfo.phoneNumber || '';
            this.detAdd = userInfo.etcAddress || '';
            this.genAdd = userInfo.basicAddress || '';
            this.zipcode = userInfo.postCode || '';
            this.userNm = userInfo.userName || '';
            this.userMobile = userInfo.userMobileNum || '';
            this.schulMstr = userInfo.orgName || '';

            const aa = new Date();
            this.d_year = aa.getFullYear();
            this.d_month = aa.getMonth() + 1;
            this.d_day = aa.getDate();
          }

          this.loaded = true;
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {},
  destroyed() {
    if (window.jusoCallBack) {
      window.jusoCallBack = undefined;
    }
  },
};
</script>

<style lang="scss" scoped>
	::v-deep .pop_layer {
	min-width: 1024px;
	left: calc(50% - 500px);
	margin-left: 0;
	}
	::v-deep .pop_layer .price_color {
		color: #0177c0;
	}
	@media all and (max-width: 1024px) {
	::v-deep .pop_layer {
		min-width: 100%;
		left: 0;
	}
	}
	.popup_wrap {
	display: inline-block;
	& a {
		cursor: pointer;
	}
	}

	/*확약서 작성*/
	.rg_promise_wrap{width:100%;display:block;margin-bottom:10px;margin-top:10px;}
	.rg_promise_wrap h4{font-family:'NotoKrB';font-size:18px;color:#333;letter-spacing:-1.5px;padding-bottom:10px;}
	.rg_promise_box1{margin-bottom:10px;border:1px solid #ccc;padding:20px 20px;}
	.rg_promise_box1 div.rg_promise_top{width:100%;margin:0 auto;text-align:center;}
	.rg_promise_box1 div.rg_promise_top p.promise_logo{font-size:28px;font-family:'NotoKrB';letter-spacing:-1px;color:#333;margin-bottom:15px;}
	.rg_promise_box1 div.rg_promise_top p.promise_txt{font-size:20px;color:#999;margin-bottom:5px;text-align:left;}
	.rg_promise_box1 div.rg_promise_input{width:100%;}
	.rg_promise_box1 div.rg_promise_input table{width:100%; text-align: initial;}
	.rg_promise_box1 div.rg_promise_input table tr td.p_tt{width:13%;font-size:17px;letter-spacing:-1px;color:#666;line-height:180%;height:35px;}
	.rg_promise_box1 div.rg_promise_input table tr td.p_tt01{text-align:right;width:10%;font-size:17px;letter-spacing:-1px;color:#666;line-height:180%;}
	.rg_promise_box1 div.rg_promise_input table tr td.p_tt02{width:20%;text-align:right;}
	.rg_promise_box1 div.rg_promise_table {width:100%;padding-top:10px;}
	.rg_promise_box1 div.rg_promise_table h4 {width:100%;margin-top:20px;}
	.rg_promise_box1 div.rg_promise_table table thead th {text-align: center;background-color:#e5e5e5;border-top:2px solid #0177c1;border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;color: #31343f;vertical-align: middle;font-size:15px;font-weight: 700;}
	.rg_promise_box1 div.rg_promise_table table thead th:last-child{padding:10px 0px;border-right:none;}
	.rg_promise_box1 div.rg_promise_table table tbody td {padding:10px 0px;font-size: 15px;letter-spacing:-1px;height: 16px;text-align: center; border-bottom: 1px solid #e1e2e2; border-right: 1px solid #e1e2e2; color:#666;}
	.rg_promise_box1 div.rg_promise_table table tbody td:last-child{border-right:none;}
	.rg_promise_box1 div.rg_promise_table table thead td.tdcols{padding:10px 0px;color:#31343f;text-align:center;background-color:#efefef;border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;}
	.rg_promise_box1 div.rg_promise_table table thead td.tdcols:last-child{border-right:none;}
	.rg_promise_box1 div.rg_promise_table table tbody td.p_room{color:#333;font-weight:300;padding: 6px 0 7px;}
	.rg_promise_box1 div.rg_promise_table table tbody td.p_num{color:#0177c1;font-weight:300;padding: 6px 0 7px;}
	.rg_promise_box1 div.rg_promise_txt{width:100%;margin-top:30px;}
	.rg_promise_box1 div.rg_promise_txt p.rg_p01{font-size:17px;letter-spacing:-1px;margin-bottom:30px;}
	.rg_promise_box1 div.rg_promise_txt div.rg_p02{width:100%;border:1px solid #ccc;padding-bottom:10px;}
	.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p03{font-size:15px;letter-spacing:-1px;color:#333;font-weight:600;margin:10px;}
	.rg_promise_box1 div.rg_promise_txt div.rg_p02 p.rg_p04{font-size:15px;letter-spacing:-1px;color:#666;margin:0px 10px;}
	.p_indent {float:left;margin-left:10px;}
	.p_indent + div {margin:0 10px 0 20px;} 
	.rg_promise_box1 div.rg_promise_txt div.rg_p02 span.rg_under{text-decoration:underline;}
	.rg_promise_box1 div.rg_promise_table p.rg_p05{text-align:right;font-size:17px;letter-spacing:-1px;margin-top:40px;}
	.rg_promise_box1 div.rg_promise_table p.rg_p06{text-align:right;font-size:17px;letter-spacing:-1px;margin-top:10px;}
	.rg_promise_box1 div.rg_promise_table p.rg_p07{text-align:center;font-size:22px;letter-spacing:4px;color:#333;font-weight:bold;margin:20px 0 20px 0;}
	.rg_p03.title {color: rgb(102, 102, 102); font-size: 18px;margin-bottom:10px;}
	.rg_p03.content {color: rgb(102, 102, 102); font-size: 17px;margin-bottom:10px;}
			
</style>
